export default __webpack_public_path__ + "static/media/ct213-8.9d208984.png";